export default __webpack_public_path__ + "static/media/AI.c2cafe0a.svg";